import { DealerMinimal } from './dealer-minimal';

export class RemittancePendingContractsRequest {
  //#region : Constructor :
  constructor(dealerCode?: string, programCode?: string) {
    this.dealerCode = dealerCode;
    this.programCode = programCode;
    this.dealer = null;
  }
  //#endregion

  //#region : Properties :
  public userName: string;
  public dealerCode: string;
  public programCode: string;
  public dealer: DealerMinimal;
  public useSefi: boolean;
  //#endregion
}
